(() => {
  document.querySelectorAll('.sl[data-section]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const data = JSON.parse(root.querySelector('[data-product-json]').textContent);
    const $ = (s) => root.querySelector(s);
    const $$ = (s) => [...root.querySelectorAll(s)];
    const fmt = (cents) => {
      const v = (cents / 100).toFixed(2);
      return (data.money || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    };
    const colourSel = $('[data-colour]');
    const packs = $$('[data-pack]');
    let pack = (packs.find((b) => b.dataset.pack === data.defaultPack) || packs[1] || packs[0]).dataset.pack;
    let qty = 1;
    const find = (c, pk) => data.variants.find((v) => v.o1 === c && v.o2 === pk);
    const smallest = () => data.variants.filter((v) => v.o1 === colourSel.value).sort((a, b) => a.price - b.price)[0];

    // Gallery
    const main = $('[data-main]');
    const thumbs = $$('[data-thumb]');
    let idx = 0;
    const show = (i) => {
      if (!thumbs.length) return;
      idx = (i + thumbs.length) % thumbs.length;
      main.src = thumbs[idx].dataset.thumb;
      thumbs.forEach((t, k) => t.classList.toggle('is-on', k === idx));
    };
    thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
    $('[data-next]').addEventListener('click', () => show(idx + 1));

    const render = (fromColour) => {
      const v = find(colourSel.value, pack);
      const base = smallest();
      packs.forEach((b) => {
        const pv = find(colourSel.value, b.dataset.pack);
        b.classList.toggle('is-on', b.dataset.pack === pack);
        if (!pv) return;
        b.querySelector('[data-pp]').textContent = fmt(pv.price);
        const pc = b.querySelector('[data-pc]');
        pc.textContent = pv.compare > pv.price ? fmt(pv.compare) : '';
        const save = b.querySelector('[data-save]');
        if (pv.compare > pv.price) { save.hidden = false; save.textContent = 'Save ' + Math.round((1 - pv.price / pv.compare) * 100) + '%'; } else { save.hidden = true; }
      });
      if (!v) return;
      $('[data-price]').textContent = fmt(v.price) + ' USD';
      const cmp = $('[data-compare]');
      cmp.textContent = v.compare > v.price ? fmt(v.compare) + ' USD' : '';
      $('[data-sale]').hidden = !(v.compare > v.price);
      $('[data-total]').textContent = fmt(v.price * qty);
      $('[data-qty]').textContent = qty;
      if (fromColour && v.img) {
        main.src = v.img;
        const t = thumbs.findIndex((x) => String(x.dataset.mediaId) === String(v.media));
        if (t >= 0) { idx = t; thumbs.forEach((x, k) => x.classList.toggle('is-on', k === t)); }
      }
      return base;
    };
    colourSel.addEventListener('change', () => render(true));
    packs.forEach((b) => b.addEventListener('click', () => { pack = b.dataset.pack; render(false); }));
    $('[data-minus]').addEventListener('click', () => { qty = Math.max(1, qty - 1); render(false); });
    $('[data-plus]').addEventListener('click', () => { qty += 1; render(false); });

    const err = $('[data-error]');
    const fail = (m) => { err.hidden = false; err.textContent = m; };

    $('[data-buy]').addEventListener('click', () => {
      const v = find(colourSel.value, pack);
      if (!v) return;
      window.location.href = '/cart/' + v.id + ':' + qty;
    });

    // Drawer
    const drawer = $('[data-drawer]');
    const open = () => { drawer.hidden = false; document.documentElement.classList.add('sl-lock'); };
    const close = () => { drawer.hidden = true; document.documentElement.classList.remove('sl-lock'); };
    $$('[data-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });

    const refresh = async () => {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      const box = $('[data-items]');
      box.innerHTML = cart.items.length ? '' : '<p class="sl-empty">Your cart is empty.</p>';
      cart.items.forEach((it, line) => {
        const el = document.createElement('article');
        el.className = 'sl-item';
        const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
        el.innerHTML = `<img src="${img}" alt="" width="72" height="72"><div><h3></h3><div class="sl-iq"><button type="button" data-d aria-label="Decrease quantity">−</button><span>${it.quantity}</span><button type="button" data-i aria-label="Increase quantity">+</button></div></div><div class="sl-ir"><strong>${fmt(it.final_line_price)}</strong><button type="button" data-r aria-label="Remove">Remove</button></div>`;
        el.querySelector('h3').textContent = it.product_title + (it.variant_title ? ' · ' + it.variant_title : '');
        const change = async (q) => { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line + 1, quantity: q }) }); refresh(); };
        el.querySelector('[data-d]').addEventListener('click', () => change(it.quantity - 1));
        el.querySelector('[data-i]').addEventListener('click', () => change(it.quantity + 1));
        el.querySelector('[data-r]').addEventListener('click', () => change(0));
        box.appendChild(el);
      });
      $$('[data-up]').forEach((u) => {
        const added = cart.items.some((it) => String(it.variant_id) === u.dataset.up);
        const b = u.querySelector('[data-upadd]');
        b.disabled = added; b.textContent = added ? 'Added ✓' : 'Add';
      });
      $('[data-subtotal]').textContent = fmt(cart.total_price) + ' USD';
      $('[data-checkout]').classList.toggle('is-off', !cart.items.length);
      document.querySelectorAll('.cart-count, [data-cart-count]').forEach((n) => { n.textContent = cart.item_count; });
    };
    const add = async (id, q) => {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: q }] }) });
      if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || 'Could not add to cart'); }
    };
    $('[data-add]').addEventListener('click', async (e) => {
      const v = find(colourSel.value, pack);
      if (!v) return;
      const btn = e.currentTarget; // currentTarget vira null depois do await
      btn.disabled = true; err.hidden = true;
      try { await add(v.id, qty); await refresh(); open(); } catch (x) { fail(x.message); }
      btn.disabled = false;
    });
    $$('[data-upadd]').forEach((b) => b.addEventListener('click', async () => {
      b.disabled = true;
      try { await add(Number(b.closest('[data-up]').dataset.up), 1); } catch (x) { /* ignore */ }
      refresh();
    }));

    // Gallery slider (dark section)
    const slides = $$('[data-slide]');
    let s = 0;
    const go = (i) => { s = (i + slides.length) % slides.length; slides.forEach((x, k) => x.classList.toggle('is-on', k === s)); };
    $$('[data-prev]').forEach((b) => b.addEventListener('click', () => go(s - 1)));
    $$('[data-nextslide]').forEach((b) => b.addEventListener('click', () => go(s + 1)));

    render(true);
  });
})();
